import * as React from 'react';
import type { SVGProps } from 'react';
const SvgStreamlineDashedProgressCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <circle
      cx={12}
      cy={12}
      r={8}
      stroke="#F83"
      strokeDasharray="4 4"
      strokeWidth={2}
    />
  </svg>
);
export default SvgStreamlineDashedProgressCircle;
